var map = {
	"./general/DocsIcon--bluecheckmark.svg": 1673,
	"./general/DocsIcon--country.svg": 1674,
	"./general/DocsIcon--github.svg": 1675,
	"./general/DocsIcon--guide.svg": 1676,
	"./general/DocsIcon--list.svg": 1677,
	"./general/DocsIcon--locale.svg": 1678,
	"./general/DocsIcon--thumbsdown.svg": 1679,
	"./general/DocsIcon--thumbsup.svg": 1680,
	"./general/DocsIcon--video.svg": 1681,
	"./nav/DocsIcon--account.svg": 1682,
	"./nav/DocsIcon--business.svg": 1683,
	"./nav/DocsIcon--developertools.svg": 1684,
	"./nav/DocsIcon--financialservices.svg": 1685,
	"./nav/DocsIcon--home.svg": 1686,
	"./nav/DocsIcon--mobilenav.svg": 1687,
	"./nav/DocsIcon--payments.svg": 1688,
	"./nav/DocsIcon--reference.svg": 1689,
	"./nav/DocsIcon--security.svg": 1690,
	"./product/DocsIcon--account.svg": 1691,
	"./product/DocsIcon--atlas.svg": 1692,
	"./product/DocsIcon--capital.svg": 1693,
	"./product/DocsIcon--checkout.svg": 1694,
	"./product/DocsIcon--climate.svg": 1695,
	"./product/DocsIcon--connect.svg": 1696,
	"./product/DocsIcon--corporatecard.svg": 1697,
	"./product/DocsIcon--dashboard.svg": 1698,
	"./product/DocsIcon--developertools.svg": 1699,
	"./product/DocsIcon--elements.svg": 1700,
	"./product/DocsIcon--gateddocs.svg": 1701,
	"./product/DocsIcon--identity.svg": 1702,
	"./product/DocsIcon--implementationguides.svg": 1703,
	"./product/DocsIcon--invoicing.svg": 1704,
	"./product/DocsIcon--issuing.svg": 1705,
	"./product/DocsIcon--partners.svg": 1706,
	"./product/DocsIcon--payments.svg": 1707,
	"./product/DocsIcon--radar.svg": 1708,
	"./product/DocsIcon--reporting.svg": 1709,
	"./product/DocsIcon--sigma.svg": 1710,
	"./product/DocsIcon--styleguide.svg": 1711,
	"./product/DocsIcon--tax.svg": 1712,
	"./product/DocsIcon--terminal.svg": 1713,
	"./product/DocsIcon--treasury.svg": 1714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1672;